import { Resource as r, API as c, SourceType as a } from "@coveo/platform-client";
const i = [a.JIVE, a.JIVE_HOSTED], s = class s extends r {
  async full() {
    const t = await this.api.get(s.baseUrl);
    return {
      ...t,
      connectors: t.connectors.map((e) => ({
        ...e,
        deprecated: i.includes(e.type)
      }))
    };
  }
};
s.baseUrl = `/rest/organizations/${c.orgPlaceholder}/license`;
let o = s;
export {
  o as LicenseInternalResource
};
//# sourceMappingURL=LicenseInternalResource.js.map
